export default __webpack_public_path__ + "static/media/food.b88695ce.jpg";